import TeamMemberCard from '@/common/interfaces/modules/TeamMemberCard';
import { editHtml } from '@/utils/htmlUtils';

export interface BioLockupBlockViewModel extends TeamMemberCard {}

export const convert = (data: BioLockupBlockViewModel): BioLockupBlockViewModel => {
  data.Text = editHtml(data.Text, [], false);
  return data;
};
